import { Hide, Show } from '@hover/blueprint/chakra';
import { breakpoints } from '@hover/blueprint/foundation';
import type { ReactNode } from 'react';
import React from 'react';

import { SkipSSR } from 'src/shared/components/SSR/SkipSSR';

const OnlyShowInLandscape = ({ children }: { children: ReactNode }) => (
  <SkipSSR>
    <Show breakpoint={`(min-width: ${breakpoints?.tablet})`}>{children}</Show>
  </SkipSSR>
);

const OnlyShowInPortrait = ({ children }: { children: ReactNode }) => (
  <SkipSSR>
    <Hide breakpoint={`(min-width: ${breakpoints?.tablet})`}>{children}</Hide>
  </SkipSSR>
);

const calcContentNavigationGridTemplate = (
  isFocusedView: boolean,
  isDesktopSize: boolean,
  headerHeight: number,
): { templateColumns: string; templateRows: string; templateAreas: string } => {
  if (isDesktopSize) {
    if (isFocusedView) {
      return {
        templateColumns: '100% 0px',
        templateRows: `calc(100vh - ${headerHeight}px)`,
        templateAreas: `"content navigation"`,
      };
    }

    return {
      templateColumns: 'calc(100% - 410px) 1fr',
      templateRows: `calc(100vh - ${headerHeight}px)`,
      templateAreas: `"content navigation"`,
    };
  }
  if (isFocusedView) {
    return {
      templateColumns: '100%',
      templateRows: `calc(100vh - ${headerHeight}px) 0px`,
      templateAreas: `"content"\n"navigation"`,
    };
  }

  return {
    templateColumns: '100%',
    templateRows: 'min-content min-content',
    templateAreas: `"content"\n"navigation"`,
  };
};

export {
  OnlyShowInLandscape,
  OnlyShowInPortrait,
  calcContentNavigationGridTemplate,
};
